
import { Component, Mixins, Prop } from "vue-property-decorator";
import { getAddressString } from "@/utils/address.util";
import AuthMixin from "@/common/mixins/auth.mixin";
import { VacancyDto } from "@/types/vacancy.type";
import { VacancyStatus } from "@/types/enums.type";

@Component
export default class VacancyCardComponent extends Mixins(AuthMixin) {
  @Prop() vacancy!: VacancyDto;

  VacancyStatus = VacancyStatus;
  Math = Math;

  showApplicantModal(): void {
    this.$emit("applicantClick", this.vacancy.id);
  }

  onEdit(): void {
    this.$emit("edit", this.vacancy.id);
  }

  onDelete(): void {
    this.$emit("delete", this.vacancy.id);
  }

  onFill(): void {
    this.$emit("fill", this.vacancy.id);
  }

  onRepost(): void {
    this.$emit("repost", this.vacancy.id);
  }

  get address(): string {
    return getAddressString(this.vacancy);
  }

  get canEdit(): boolean {
    return this.vacancy.schedulerIds.some(id => id === this.userInfo()?.sub);
  }
}
